<template>
  <div class="status-top">
    <div class="left-metrics">
      <GrowthMetricCard
        v-for="item in mainMetrics"
        :key="item.name"
        :name="item.name"
        :value="item.value"
        :unit="item.unit"
      />
    </div>
    <div class="right-metrics">
      <GrowthMetricCard name="偏弱地块" value="3.1" unit="万亩" />
      <div class="small-metrics">
        <GrowthMetricCard
          v-for="item in subMetrics"
          :key="item.name"
          :name="item.name"
          :value="item.value"
          :unit="item.unit"
          size="small"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import GrowthMetricCard from "./GrowthMetricCard.vue";

const mainMetrics = [
  { name: "全县生育进度", value: "62", unit: "%" },
  { name: "优良地块", value: "26.8", unit: "万亩" },
];

const subMetrics = [
  { name: "监测地块", value: "126", unit: "块" },
  { name: "在线传感器", value: "386", unit: "台" },
  { name: "病虫害风险", value: "低", unit: "" },
];
</script>

<style lang="less" scoped>
.status-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  min-height: 0;
}

.left-metrics,
.right-metrics {
  min-height: 0;
  display: grid;
  gap: 18px;
}

.left-metrics {
  grid-template-rows: repeat(2, 1fr);
}

.right-metrics {
  grid-template-rows: 1fr 1fr;
}

.small-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}
</style>
